import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useShippingNextStepsExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.ShippingNextStepsExperiment,
        AmplitudeVariants.ShippingNextStepsExperiment.SeeShippingSteps
    );
